import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';

class ActivityRulesModalStore extends BaseModalStore {
  @observable serverName = '新服名称';
  @observable bindGoldText = '0';

  setServerName(serverName) {
    this.serverName = serverName || '新服名称';
  }

  /** 将 get_config.bind_gold 的格式化结果同步给活动规则弹窗。 */
  setBindGoldText(bindGoldText) {
    this.bindGoldText = bindGoldText || '0';
  }
}

export default ActivityRulesModalStore;
